module.exports = __webpack_public_path__ + "media/success.c03325cb.wav";